"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsAndStandingsReferenceSchema = void 0;
exports.ResultsAndStandingsReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/results-standings.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ResultsAndStandingsReference",
    "description": "A content type that allows to display the results of events or races.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:results-standings"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy1zdGFuZGluZ3Muc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvcmVmZXJlbmNlL2NvbnRlbnQvcmVzdWx0cy1zdGFuZGluZ3Muc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsS0FBSyxFQUFFLGlGQUFpRjtJQUN4RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSw4QkFBOEI7SUFDdkMsYUFBYSxFQUFFLHVFQUF1RTtJQUN0RixNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sSUFBSTtLQUNMO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFO2dCQUNOLDhCQUE4QjthQUMvQjtZQUNELE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLDZFQUE2RTtTQUN6RjtLQUNGO0NBQ0YsQ0FBQSJ9